export default {
    credit: 'Credit',
    classHour: 'Class hour',
    todayTask: 'Today\'s mission',
    curriculum: 'Course',
    special: 'Subject',
    examination: 'Exam',
    research: 'Survey',
    class: 'Class',
    live: 'Live',
    scjp: 'Certification exam',
    view: 'People visit',
    anotherGroup: 'Change',
    more: 'Look at all',
    branch: 'Branch',
    door: 'Door',
    personTime: 'Person time',
    second: 'Second',
    views: 'Number of visitors',
    noStudent: 'No student is on the list',
    goQuestion: 'Enter',
    currentRanking: 'Your current ranking',
    location: 'Bit',
    notRanking: 'You are not on the ranking.'
};
